import React from 'react';
import './Intro.scss';
import { useTranslation } from 'react-i18next';
import { Config } from '../../models';

interface IntroProps {
  email: string;
  config: Config;
}

export const Intro = React.memo(
  ({ config, email }: IntroProps): JSX.Element => {
    const { t } = useTranslation();

    return (
      <div className="intro home-content-item">
        {config.appConfig.hasHeaderEyebrow && (
          <p className="intro-header-eyebrow">{t('headerEyebrow')}</p>
        )}
        <h1 className="intro-header">{t('header', { email })}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html: t('content', { email }),
          }}
          className="intro-content"
        ></p>
      </div>
    );
  },
);
